<template>
	<v-row>
		<v-col>
			<package-card @selected="onSelected" v-for="cPackage in lottery.packages" :key="cPackage.id" :cPackage="cPackage"/>
		</v-col>
	</v-row>
</template>

<script>
	import PackageCard from "./PackageCard";
	export default {
		name: "packages-cards",
		components: {PackageCard},
		computed:{
			lottery() {
				return this.$store.state.LotteryModule.lottery;
			}
		},
		methods:{
			onSelected(selected){
				this.$emit("selected",selected);
			}
		}
	};
</script>

<style scoped>

</style>
